import 'bootstrap';

$(function() {
  $('.close').click(function () {
    $('iframe').attr('src', $('iframe').attr('src'));
  });
});
